<template>

  <v-list expand>

    <!-- Tablestruktur durch div flex ersetzen?
             Größenkorrektur media mit transform: scale möglich? Oder in Einzelbilder aufteilen? geht, aber dann Tablestruktur auflösen
             i18n nötig? Bind mit div möglich oder nur mit vuetify Elementen?
        -->

    <v-card-text class="onprimary--text">
      Starkregenereignis
    <!--
        <div style="width: 100%; display: flex; border: solid 1px blue;">

            <div class="starkregenControl">
            <img src="../../static/images/StarkregenScenarioControl5.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr030' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 30-jährliches Ereignis / Starkregenindex 5">
            </div><div class="starkregenControl">
            <img src="../../static/images/StarkregenScenarioControl6.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr050' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 50-jährliches Ereignis / Starkregenindex 6">
            </div><div class="starkregenControl">
            <img src="../../static/images/StarkregenScenarioControl7.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr100' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 100-jährliches Ereignis / Starkregenindex 7">
            </div><div class="starkregenControl">
            <img src="../../static/images/StarkregenScenarioControl10.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr200' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 200-jährliches Ereignis / Starkregenindex 10">
            </div>
        -->
    <!-- funktioniert tatsächlich für xs gut -->
    <!--
        <div style="width: 100%; display: inline-flex;">

            <v-img src="../../static/images/StarkregenScenarioControl5.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr030' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 30-jährliches Ereignis / Starkregenindex 5"></v-img>
            <v-img src="../../static/images/StarkregenScenarioControl6.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr050' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 50-jährliches Ereignis / Starkregenindex 6"></v-img>
            <v-img src="../../static/images/StarkregenScenarioControl7.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr100' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 100-jährliches Ereignis / Starkregenindex 7"></v-img>
            <v-img src="../../static/images/StarkregenScenarioControl10.jpg"
                v-bind:class="{ activeStarkregen: this.activeScenario === 'sr200' }"
                :id="this.displayedLayers[0].get('lid')" class="starkregenBorder starkregenControl"
                @click="this.layerSelectionStarkregen"
                title="Starkregen Szenario 200-jährliches Ereignis / Starkregenindex 10"></v-img>
            </div>
-->

    <div style="width: 100%; display: inline-flex;">
      <div v-bind:class="{ activeStarkregen: this.activeScenario === 'sr030' }" :id="this.displayedLayers[0].get('lid')"
        class="starkregenBorder starkregenControl" style="background-position: 0 0"
        @click="this.layerSelectionStarkregen" title="Starkregen Szenario 30-jährliches Ereignis / Starkregenindex 5">
      </div>

      <div v-bind:class="{ activeStarkregen: this.activeScenario === 'sr050' }" :id="this.displayedLayers[1].get('lid')"
        class="starkregenBorder starkregenControl" style="background-position: -79px 0"
        @click="this.layerSelectionStarkregen" title="Starkregen Szenario 50-jährliches Ereignis / Starkregenindex 6">
      </div>

      <div v-bind:class="{ activeStarkregen: this.activeScenario === 'sr100' }" :id="this.displayedLayers[2].get('lid')"
        class="starkregenBorder starkregenControl" style="background-position: -158px 0"
        @click="this.layerSelectionStarkregen" title="Starkregen Szenario 100-jährliches Ereignis / Starkregenindex 7">
      </div>

      <div v-bind:class="{ activeStarkregen: this.activeScenario === 'sr200' }" :id="this.displayedLayers[3].get('lid')"
        class="starkregenBorder starkregenControl" style="background-position: -235px 0"
        @click="this.layerSelectionStarkregen" title="Starkregen Szenario 200-jährliches Ereignis / Starkregenindex 10">
      </div>
    </div>

    <!-- TODO Opacitiy Slider anbieten? -->
    <wgu-layeropacitycontrolcustom :layer="activeLayer"  v-if="activeLayer" />

    <v-list-item v-if="showLegends && activeLayer">
      <wgu-layerlegendimagecustom :layer="activeLayer" :mapView="mapView" />
    </v-list-item>
   </v-card-text>
  </v-list>
</template>
    <!-- TODO Legende. Festes Bild oder aus Geoserver? (getLegend Request, vielleicht Componente [custom] nutzen?)-->
    <!-- TODO Opacitiy Slider anbieten? -->

<script>
import { WguEventBus } from '../../../src/WguEventBus'
import { Mapable } from '../../../src/mixins/Mapable';
import LayerLegendImageCustom from './LayerLegendImageCustom.vue'
import LayerOpacityControlCustom from './LayerOpacityControlCustom.vue';

// import LayerListItem from './LayerListItem'

export default {
  name: 'wgu-layerliststarkregen',
  components: {
    'wgu-layerlegendimagecustom': LayerLegendImageCustom,
    'wgu-layeropacitycontrolcustom': LayerOpacityControlCustom
  },
  mixins: [Mapable],
  props: {
    showLegends: { type: Boolean, required: true },
    showOpacityControls: { type: Boolean, required: true },
    layersTopicName: { type: String, required: true }
  },
  data () {
    return {
      mapView: null,
      layers: [],
      activeLayer: null,
      activeScenario: null
    }
  },
  methods: {
    /**
         * This function is executed, after the map is bound (see mixins/Mapable).
         * Bind to the layers from the OpenLayers map.
         */
    onMapBound () {
      this.layers = this.map.getLayers().getArray();
      this.mapView = this.map.getView();

      this.displayedLayers.forEach(l => {
        if (l.getVisible()) {
          this.activeScenario = l.get('lid')
          this.activeLayer = l

          /* inform 3D-ModuleCaard of initial scenario */
          WguEventBus.$emit('button3d_update_scenario', l.get('lid'));
        }
      }
      );
    },
    layerSelectionStarkregen (event) {
      // console.log(event.target.id);
      this.activeScenario = event.target.id;
      this.adjustLayerVisibility(event.target.id);
    },
    adjustLayerVisibility (makeThisLayerVisible) {
      this.displayedLayers.forEach(l => {
        if (l.get('lid') !== makeThisLayerVisible && l.get('lid') !== 'hw_schutz_fcl') {
          l.setVisible(false)
        } else {
          l.setVisible(true)
          this.activeLayer = l

          /* inform 3D-ModuleCaard of scenario change */
          WguEventBus.$emit('button3d_update_scenario', l.get('lid'));
        }
      }

      )
    }
  },
  computed: {
    /**
         * Reactive property to return the OpenLayers layers to be shown in the control.
         * Remarks: The 'displayInLayerList' attribute should default to true per convention.
         */
    displayedLayers () {
      return this.layers
        .filter(layer => layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer') && layer.get('layerGroup') === this.layersTopicName)
        .reverse();
    }
  }
}
</script>

<style>

.v-card__text {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

@media (max-width: 1200px) {
  .v-card__text {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
}

</style>

<style scoped>

.v-list-item {
    padding-left: 4px !important;
}

  .starkregenControl {
    width: 78px;
    height: 100px;
    cursor: pointer;
    background: url(../../static/images/StarkregenScenarioControl.jpg) 0 0;
    margin: 0px;
    padding: 0px;
    /* transform: scale(50%, 50%); */
    /* new */
    /*
    display: inline-flex;
    flex: 0 1 auto;
    margin: 2px;
    */

}

.starkregenBorder {
    border: solid 2px #FFFFFF;
    border-radius: 7px;
}

.starkregenControl:hover {
    border: solid 2px #007bC7;
    border-radius: 7px;
    transform: scale(110%);
}

.activeStarkregen {
    border: solid 2px #00508c;
    border-radius: 7px;
}

@media (max-width: 600px) {
    .starkregenControl {
        margin: 0px;
    }
}

@media (min-width: 600px) {
    .starkregenControl {
            margin-left: 2px;
            margin-right: 2px;
        }
}

@media (min-width: 1000px) {
    .starkregenControl {
            margin-left: 3px;
            margin-right: 3px;
        }

}

@media (min-width: 1280px) {
    .starkregenControl {
            margin-left: 5px;
            margin-right: 5px;
        }
}

/* TODO: Wolkenbeschriftung als Text? */
</style>
